import { render, staticRenderFns } from "./AdminServerShortInfo.vue?vue&type=template&id=2868ca44&scoped=true&"
import script from "./AdminServerShortInfo.vue?vue&type=script&lang=js&"
export * from "./AdminServerShortInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminServerShortInfo.vue?vue&type=style&index=0&id=2868ca44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2868ca44",
  null
  
)

export default component.exports